import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export interface UserInfo {
  firstName: string;
  lastName: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactFormService {
  private readonly apiUrl = 'api/users/contact-email/';
  private readonly userApiUrl = 'api/users/current';

  constructor(private http: HttpClient) {}

  async getUserInfo(): Promise<UserInfo> {
    return firstValueFrom(
      this.http.get<UserInfo>(this.userApiUrl)
    );
  }

  async submitContactForm(formData: ContactFormData): Promise<any> {
    return firstValueFrom(
      this.http.post(this.apiUrl, formData)
    );
  }
}